import React from "react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import { useFormikContext } from "formik";

import { DateInput, TimeInput } from "@/component/input";
// import SwitchComponent from "@/component/input/switch";
import Texteditor from "@/component/texteditor";
import {
  MedicationForm,
  PREFERRED_TIME,
  TypeMedication,
} from "@/interfaces/IServiceUser";
import { DayTime } from "@/interfaces/ITaskManagement";
import { DAYTIME, LIMITS } from "@/utils/constants";

export const PREFFERED_TIME: { label: string; value: PREFERRED_TIME }[] = [
  {
    label: "Sessions",
    value: PREFERRED_TIME.TIME_PERIOD,
  },
  {
    label: "Exact time",
    value: PREFERRED_TIME.SPECIFIC_TIME,
  },
];

const DateInfo = () => {
  const { values, touched, errors, setFieldValue } =
    useFormikContext<MedicationForm>();

  const [isNeverEnding, setIsNeverEnding] = React.useState(false);

  const handleEndDateChange = (value: boolean) => {
    setIsNeverEnding(value);
    setFieldValue("endDate", value ? null : values.endDate);
  };

  const handlePreferredTime = (value: PREFERRED_TIME) => {
    setFieldValue("preferredTime", value);
    if (value === PREFERRED_TIME.SPECIFIC_TIME) {
      setFieldValue("timePeriod", []);
    } else {
      setFieldValue("specificTime", []);
    }
  };

  const handleDayTimes = (value: DayTime) => {
    if (values.timePeriod.includes(value)) {
      setFieldValue(
        "timePeriod",
        values.timePeriod.filter((el) => el !== value)
      );
    } else {
      setFieldValue("timePeriod", [...values.timePeriod, value]);
    }
  };

  return (
    <Box className="personalCare">
      <Box className="dailydata">
        <Grid container spacing={2}>
          <Grid size={12}>
            <FormGroup>
              <DateInput
                label="Start Date*"
                value={dayjs(values.startDate)}
                onChange={(date) => setFieldValue("startDate", date)}
              />
            </FormGroup>
          </Grid>
          <Grid size={12}>
            {/* <Box className="never">
              <RadioInput
                label=""
                options={[
                  {
                    label: "",
                    value: "",
                  },
                ]}
              />
            </Box>
            <FormGroup>
              <DateInput
                label="End Date"
                // value={field.value}
                // onChange={(date) => setFieldValue("endDate", date)}
              />
            </FormGroup> */}
            <FormGroup>
              <Box
                sx={{
                  color: "#1F4970",
                  fontSize: "14px",
                  fontWeight: "600",
                  padding: "12px 0px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                }}
              >
                <Box>End Date</Box>
                <Box
                  sx={{
                    color:
                      touched?.endDate && errors?.endDate
                        ? "red!important"
                        : "inherit",
                  }}
                >
                  <Checkbox
                    sx={{
                      color:
                        touched?.endDate && errors?.endDate
                          ? "red!important"
                          : "inherit",
                      "&.Mui-checked": {
                        color:
                          touched?.endDate && errors?.endDate
                            ? "red!important"
                            : "inherit",
                      },
                      padding: "0px",
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                        mr: "5px",
                      },
                    }}
                    checked={isNeverEnding}
                    onChange={(e) => handleEndDateChange(e.target.checked)}
                  />
                  Never
                </Box>
              </Box>
              <DateInput
                minDate={values.startDate}
                disabled={isNeverEnding}
                onChange={(val) => setFieldValue("endDate", val)}
                value={values.endDate ? dayjs(values?.endDate) : undefined}
                // errorText={touched?.endDate && errors?.endDate}
                errorText={
                  touched.endDate && errors.endDate ? errors.endDate : undefined
                }
              />
            </FormGroup>
          </Grid>
        </Grid>
      </Box>
      {values.type !== TypeMedication.PRN && (
        <Box>
          <Typography className="frequency">
            Select preferred timing*
          </Typography>

          <Box className="Visit">
            {PREFFERED_TIME.map((time) => (
              <Typography
                key={time.value}
                variant="h6"
                className={`weekData ${values.preferredTime === time.value ? "active" : ""}`}
                sx={[
                  {
                    margin: "0px 7px",
                    cursor: "pointer",
                  },
                  touched.preferredTime &&
                    errors.preferredTime && {
                      color: "red !important",
                      borderColor: "red !important",
                    },
                ]}
                onClick={() => handlePreferredTime(time.value)}
              >
                {time.label}
              </Typography>
            ))}
          </Box>

          <FormHelperText error={!!errors.preferredTime}>
            {touched.preferredTime && errors.preferredTime}
          </FormHelperText>
        </Box>
      )}
      <Box className="mainSession">
        {values.preferredTime === PREFERRED_TIME.TIME_PERIOD && (
          <>
            {" "}
            <Box className="Visit">
              {DAYTIME.map((time) => (
                <Typography
                  key={time.value}
                  variant="h6"
                  className={`weekData ${values.timePeriod.includes(time.value) ? "active" : ""}`}
                  sx={[
                    {
                      margin: "0px 7px",
                      cursor: "pointer",
                    },
                    touched.timePeriod &&
                      errors.timePeriod && {
                        color: "red !important",
                        borderColor: "red !important",
                      },
                  ]}
                  onClick={() => handleDayTimes(time.value)}
                >
                  {time.label}
                </Typography>
              ))}
            </Box>
            <FormHelperText error={!!errors.timePeriod}>
              {touched.timePeriod && errors.timePeriod}
            </FormHelperText>
          </>
        )}
        {values.preferredTime === PREFERRED_TIME.SPECIFIC_TIME && (
          <Grid container spacing={2}>
            {[...Array(values.howManyTimesADay)].map((_, index) => (
              <Grid
                key={index}
                size={{
                  xs: 12,
                  md: 3,
                }}
              >
                <FormGroup>
                  <TimeInput
                    value={
                      values.specificTime?.[index]
                        ? dayjs(values.specificTime?.[index])
                        : undefined
                    }
                    onChange={(value) => {
                      setFieldValue(`specificTime[${index}]`, value);
                    }}
                    errorText={
                      touched.specificTime &&
                      !values.specificTime?.[index] &&
                      errors.specificTime
                    }
                  />
                </FormGroup>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
      {/* <FormGroup>
        <span
          style={{
            fontWeight: "600",
            fontSize: "14px",
            color: "#1F4970",
            marginTop: "0.5rem",
            padding: "0 2px",
          }}
        >
          Cautionary Instructions
        </span>

        <Texteditor
          value={values.instructions}
          onChange={(value) => setFieldValue("instructions", value)}
          placeholder="Add instructions"
        />
      </FormGroup> */}
      <FormGroup>
        <span
          style={{
            fontWeight: "600",
            fontSize: "14px",
            color: "#1F4970",
            marginTop: "0.5rem",
            padding: "0 2px",
          }}
        >
          Cautionary Instructions
        </span>

        <Texteditor
          value={values.instructions}
          onChange={(value) => {
            if (value.length <= LIMITS.description) {
              setFieldValue("instructions", value);
            }
          }}
          placeholder="Add instructions"
        />

        {touched.instructions && errors.instructions && (
          <span style={{ fontSize: "12px", color: "red" }}>
            {errors.instructions}
          </span>
        )}
      </FormGroup>
      {/* <Box className="add">
        <Typography variant="h6">Show this medication in the roster</Typography>
        <SwitchComponent
          checked={values.showOnRoster}
          onChange={(_, checked) => setFieldValue("showOnRoster", checked)}
        />
      </Box> */}
    </Box>
  );
};

export default DateInfo;
